import { ActionPlanContextType } from '../../../../services/types/ActionPlan';
import { serviceReducer } from '../../../../shared/hooks/serviceReducer';
import { Action, ApiState } from '../../../../types';

const actionPlanReducer = (
  state: ApiState<ActionPlanContextType, string>,
  action: Action<ActionPlanContextType, string>
): ApiState<ActionPlanContextType, string> => serviceReducer(state, action);

export default actionPlanReducer;
